import React from 'react'

const RotateIcon = ({ className }) => (
  <svg
    className={className}
    width="50"
    height="49"
    viewBox="0 0 50 49"
    xmlns="http://www.w3.org/2000/svg">
    <g id="Page-1" fill="none" fillRule="evenodd">
      <g id="iPad" transform="translate(-360 -649)" fillRule="nonzero">
        <g id="Group" transform="translate(360 648)">
          <path
            d="M35,18 C23.954305,18 15,26.954305 15,38"
            id="Oval"
            stroke="#00AEEF"
            strokeWidth="6"
            transform="matrix(0 1 1 0 -3 3)"
          />
          <polygon
            id="Rectangle-4"
            fill="#00AEEF"
            transform="scale(1 -1) rotate(-45 -12.153 0)"
            points="37.517767 13.0281746 37.517767 23.6997475 26.8461941 23.6997475"
          />
          <path
            d="M0,48 L40,48"
            id="Path-7"
            stroke="#979797"
            strokeWidth="4"
            strokeDasharray="6,5"
          />
          <path
            d="M29,19 L66,19"
            id="Path-7-Copy-2"
            stroke="#00AEEF"
            strokeWidth="6"
            transform="rotate(90 47 19)"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default RotateIcon
